import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron",
  "use": "chevron-usage",
  "viewBox": "0 0 22 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 22 10\" id=\"chevron\">\n<path fill-rule=\"evenodd\" stroke=\"rgb(0, 0, 0)\" stroke-width=\"0px\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\" fill=\"rgb(0, 0, 0)\" d=\"M21.305,0.237 L21.305,2.037 L11.105,9.237 L0.905,2.037 L0.905,0.237 L11.105,7.437 L21.305,0.237 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol